(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mw-outlet"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.mwReady) return;
    root.dataset.mwReady = 'true';
    const cards = Array.from(root.querySelectorAll('[data-mw-card]'));
    const filters = root.querySelector('.mw-filters');
    const count = root.querySelector('[data-mw-count]');
    const updateCount = () => { if (count) count.textContent = String(cards.filter(card => !card.hidden).length) + ' / ' + cards.length; };
    if (filters && cards.length) {
      filters.hidden = false;
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-mw-filter]');
        if (!button) return;
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        cards.forEach(card => { card.hidden = button.dataset.mwFilter !== 'all' && card.dataset.power !== button.dataset.mwFilter; });
        updateCount();
      });
      updateCount();
    }
    root.querySelectorAll('[data-mw-variant]').forEach(select => {
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        const card = select.closest('[data-mw-card]');
        card.querySelector('[data-mw-price]').textContent = option.dataset.price;
        card.querySelector('[data-mw-compare-price]').textContent = option.dataset.compare;
        card.querySelector('[data-mw-compare]').hidden = !option.dataset.compare;
        const saving = card.querySelector('[data-mw-saving]');
        saving.textContent = option.dataset.saving;
        saving.hidden = !option.dataset.compare;
        card.querySelectorAll('[data-mw-product-link]').forEach(link => { link.href = option.dataset.url; });
      });
    });
    const sticky = root.querySelector('[data-mw-sticky]');
    const hero = root.querySelector('.mw-hero');
    if (sticky && hero && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      });
      observer.observe(hero);
      root.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
    }
  }
  const initAll = () => document.querySelectorAll('.mw-outlet').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-werksverkauf-galerie"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mw-factory-gallery')) {
  customElements.define('mw-factory-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mw-factory__track');
      this.slides = Array.from(this.querySelectorAll('.mw-factory__slide'));
      this.controls = this.querySelector('.mw-factory__controls');
      if (!this.track || !this.slides.length) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous = this.querySelector('[data-step="-1"]');
      this.next = this.querySelector('[data-step="1"]');
      this.count = this.querySelector('.mw-factory__count');
      this.controls.hidden = false;
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('button[data-step]');
        if (!button) return;
        const step = this.slides[1] ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : this.track.clientWidth;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.track.scrollBy({ left: Number(button.dataset.step) * step, behavior });
      }, options);
      this.track.addEventListener('scroll', () => this.update(), options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    update() {
      const left = this.track.scrollLeft;
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.previous.disabled = left <= 2;
      this.next.disabled = left >= max - 2;
      const rect = this.track.getBoundingClientRect();
      const visible = this.slides.map((slide,index) => {
        const r = slide.getBoundingClientRect();
        return r.left >= rect.left - 3 && r.right <= rect.right + 3 ? index + 1 : null;
      }).filter(Boolean);
      if (visible.length) this.count.textContent = (visible.length > 1 ? visible[0] + '–' + visible[visible.length - 1] : visible[0]) + ' / ' + this.slides.length;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-wohnen"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mount = (root) => {
    if (root.dataset.mounted === 'true') return;
    root.dataset.mounted = 'true';
    const frame = root.querySelector('[data-mww-frame]');
    const launch = root.querySelector('[data-mww-launch]');
    const status = root.querySelector('[data-mww-status]');
    const start = root.querySelector('[data-mww-start]');
    const origin = new URL(frame.dataset.src).origin;
    const seen = new Set();
    let timer;
    let started = false;
    let loaded = false;
    const emit = (name, detail = {}) => {
      root.dispatchEvent(new CustomEvent('marwona:wohnen', {
        bubbles: true, detail: { event: name, page: 'wohnen', ...detail }
      }));
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && privacy.analyticsProcessingAllowed()) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name, page: 'wohnen', ...detail });
      }
    };
    root.querySelectorAll('[data-mww-cta]').forEach(link => {
      link.addEventListener('click', () => emit('wohnen_calculator_cta', { placement: link.dataset.mwwCta }));
    });
    const receive = (event) => {
      if (!started || event.origin !== origin || event.source !== frame.contentWindow) return;
      const data = event.data;
      if (!data || typeof data !== 'object') return;
      if (data.type === 'lovable-resize' && Number.isFinite(data.height) && data.height >= 200 && data.height <= 50000) {
        frame.style.height = `${Math.ceil(data.height)}px`;
        status.hidden = true;
        clearTimeout(timer);
        if (!loaded) { loaded = true; emit('wohnen_calculator_ready'); }
      }
      if (data.type === 'lovable-act' && Number.isInteger(data.act) && data.act >= 1 && data.act <= 5) {
        if (!seen.has(data.act)) {
          seen.add(data.act);
          emit('wohnen_calculator_step_view', { step: data.act });
        }
        const rect = frame.getBoundingClientRect();
        if (rect.top < 0 || rect.top > window.innerHeight * .6) {
          frame.scrollIntoView({ behavior: 'auto', block: 'start' });
        }
      }
    };
    window.addEventListener('message', receive);
    start.addEventListener('click', () => {
      if (started) return;
      started = true;
      launch.hidden = true;
      frame.hidden = false;
      status.hidden = false;
      status.textContent = status.dataset.loading;
      frame.src = frame.dataset.src;
      emit('wohnen_calculator_open');
      timer = setTimeout(() => {
        if (!loaded) { status.hidden = false; status.textContent = status.dataset.slow; }
      }, 15000);
    });
    const cleanup = event => {
      if (event.target.contains(root)) {
        window.removeEventListener('message', receive);
        clearTimeout(timer);
        document.removeEventListener('shopify:section:unload', cleanup);
      }
    };
    document.addEventListener('shopify:section:unload', cleanup);
  };
  document.querySelectorAll('[data-mww-wohnen]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-mww-wohnen]').forEach(mount));
})();


  } catch(e) { console.error(e); }
})();
})();
